








import { defineComponent, computed, watchEffect } from '@nuxtjs/composition-api';

import { useFullSizedImage } from '@/composables/image';

export default defineComponent({
  name: 'HighResolutionImage',
  props: {
    image: {
      type: Object,
      required: true,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { emit }) {
    const { image, imageLoading } = useFullSizedImage(props.image.id, computed(() => props.enabled));
    const imageOrFallback = computed(() => {
      if (image.value)
        return {
          image: image.value,
          loaded: true,
        };
      else
        return {
          image: props.image,
          loaded: false,
        };
    });

    watchEffect(() => {
      if (image.value && !imageLoading.value)
        emit('load', image.value);
    });

    return {
      imageOrFallback,
      imageLoading,
    };
  },
});
